//REGISTER
export const POST_FAKE_REGISTER = "/post-fake-register"

//LOGIN
export const POST_FAKE_LOGIN = "/post-fake-login"
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login"
export const POST_FAKE_PASSWORD_FORGET = "/fake-forget-pwd"
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd"
export const SOCIAL_LOGIN = "/social-login"

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile"
export const POST_EDIT_PROFILE = "/post-fake-profile"

//PRODUCTS
export const GET_PRODUCTS = "/products"
export const GET_PRODUCTS_DETAIL = "/product"

//CALENDER
export const GET_EVENTS = "/events"
export const ADD_NEW_EVENT = "/add/event"
export const UPDATE_EVENT = "/update/event"
export const DELETE_EVENT = "/delete/event"
export const GET_CATEGORIES = "/categories"

//CHATS
export const GET_CHATS = "/chats"
export const GET_GROUPS = "/groups"
export const GET_CONTACTS = "/contacts"
export const GET_MESSAGES = "/messages"
export const ADD_MESSAGE = "/add/messages"

//ORDERS
export const GET_ORDERS = "/orders"

//CART DATA
export const GET_CART_DATA = "/cart"

//CUSTOMERS
export const GET_CUSTOMERS = "/customers"

//SHOPS
export const GET_SHOPS = "/shops"

//CRYPTO
export const GET_WALLET = "/wallet"
export const GET_CRYPTO_ORDERS = "/crypto/orders"

//INVOICES
export const GET_INVOICES = "/invoices"
export const GET_INVOICE_DETAIL = "/invoice"

//PROJECTS
export const GET_PROJECTS = "/projects"
export const GET_PROJECT_DETAIL = "/project"

//TASKS
export const GET_TASKS = "/tasks"

//CONTACTS
export const GET_USERS = "/users"
export const GET_USER_PROFILE = "/user"

export const UGIFTDEV = "https://sg.ugiftglobal.com"
export const UGIFT_STAGING_POST_GET_CATEGORY =
  UGIFTDEV + "/api/external/products/"
export const UGIFT_STAGING_POST_AUTH = UGIFTDEV + "/api/external/auth/"
export const UGIFT_STAGING_GIFT = UGIFTDEV + "/api/external/giftcards/"
export const UGIFT_STAGING_PROFILE = UGIFTDEV + "/api/external/profile/"
export const UGIFT_STAGING_EVOUCHER = UGIFTDEV + "/api/external/evoucher/"
export const UGIFT_STAGING_FRONTEND = UGIFTDEV + "/api/external/frontend/"
export const UGIFT_STAGING_BASKET = UGIFTDEV + "/api/external/basket/"
export const UGIFT_STAGING_ORDER = UGIFTDEV + "/api/external/order/"
export const UGIFT_STRIPE_ORDER =
  "https://uat-paas-gateway.e-buy.com/paas/micro/cashier/createTrade"

// export const DANAWADEV = "https://danawa.touchsales.net"
export const DANAWADEV = "http://172.16.15.2"
// export const DANAWADEV = "http://localhost/danawa"
export const DANAWA_POST_MEMBER = DANAWADEV + "/api/external/member/"
export const DANAWA_POST_FRONTEND = DANAWADEV + "/api/external/frontend/"
export const DANAWA_POST_BASKET = DANAWADEV + "/api/external/basket/"
